import { IFormValues } from './interfaces';

export const DEFAULT_VALUES: IFormValues = {
  title: '',
  content: '',
  image: '',
  link: null,
  active: false,
  publication_period: null,
};

export const FILE_MAXIMUM_SIZE = 2097152;
